module.exports = __webpack_public_path__ + "static/img/physicalTrainingCol.19676f06.svg";